import React from "react";
import {
  Box,
  Button,
  Dialog,
  Heading,
  Stack,
  Text,
  useTracking,
} from "@origin-digital/ods-core";

const BUSINESS_ADDRESS_TITLE = "Great, we have business plans for your address";

const BusinessAddressTitle = ({ children }: React.PropsWithChildren) => (
  <Stack space="large">
    <img
      src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_business.svg"
      alt=""
      width="88"
      height="88"
    />
    <Heading variant="h3">{children}</Heading>
  </Stack>
);

interface BusinessAddressDialogProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}

export const BusinessAddressDialog = ({
  open,
  onClose,
  onContinue,
}: BusinessAddressDialogProps) => {
  const { onClickCapture: trackDialogClose } = useTracking({
    "data-id": "business-address-dialog",
    type: "Dialog",
    postClickState: "closed",
    children: BUSINESS_ADDRESS_TITLE,
  });

  const handleContinue = () => {
    trackDialogClose?.();
    onContinue();
  };

  return (
    <Dialog
      id="business-address-dialog"
      data-id="business-address-dialog"
      title={BUSINESS_ADDRESS_TITLE}
      titleComponent={BusinessAddressTitle}
      open={open}
      onClose={onClose}
      maxWidth="sm"
      noFullScreenOnMobile
      closeButtonColor="neutralDark"
    >
      <Stack space="large">
        <Text>
          Find the business energy plan that’s right for you. If you’re not sure
          why we have this address as a business, call us on 13 24 61. We’ll
          sort it.
        </Text>
        <Box>
          <Button onClick={handleContinue}>Continue book your move</Button>
        </Box>
      </Stack>
    </Dialog>
  );
};
